module.exports = __webpack_public_path__ + "main/assets/public/player-media-session/playing-128.75e3fe3463c457d5.jpg";